import client from './client'
import mock from './__mock__'

export default process.env.VUE_APP_MOCK === 'true' ? mock : client
